import React, { useEffect, useRef } from 'react';
import {
  MDBNavbar,
  MDBContainer,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBNavbarBrand,
} from 'mdb-react-ui-kit';

export default function Header() {
  const collapseRef = useRef(null);

  // useEffect(() => {
  //   if (collapseRef.current) {
  //     collapseRef.current.classList.add('show');
  //   }
  // }, []);

  return (
    <MDBNavbar expand='md' dark bgColor='light'> {/* 👈 changed here */}
      <MDBContainer fluid className='container'>
        <MDBNavbarBrand href='#'>
          <img src='img/klogo.png' className='logo' alt='Logo' />
        </MDBNavbarBrand>

        <div
          className='collapse navbar-collapse'
          id='navbarColor02'
          ref={collapseRef}
        >
          <MDBNavbarNav className='mb-2 mb-lg-0 d-flex flex-wrap gap-2'>
            <MDBNavbarItem className='active'>
              <MDBNavbarLink href='tel:+919070705000' className='header-content'>
                <i className='fa-solid fa-phone'></i>  +91-9070705000 
              </MDBNavbarLink>
            </MDBNavbarItem>
            <MDBNavbarItem>
              <MDBNavbarLink href='mailto:rtt.b2b@gmail.com' className='header-content'>
                <i className='fa-solid fa-envelope'></i> rtt.b2b@gmail.com
              </MDBNavbarLink>
            </MDBNavbarItem>
          </MDBNavbarNav>
        </div>
      </MDBContainer>
    </MDBNavbar>
  );
}
